import Bugsnag from "@bugsnag/js"
import clog from "@/util/clog"

if (
  typeof window === "undefined" &&
  process.env.NEXT_PUBLIC_BUGSNAG_API_KEY &&
  !Bugsnag.isStarted()
) {
  Bugsnag.start({
    apiKey: process.env.NEXT_PUBLIC_BUGSNAG_API_KEY,
    appType: "server",
    releaseStage: process.env.NEXT_PUBLIC_BUGSNAG_RELEASE_STAGE,
    appVersion: process.env.NEXT_PUBLIC_BUGSNAG_APP_VERSION,
  })
}

export const notifyBugsnag = (error: unknown) => {
  const typedError =
    error instanceof Error
      ? error
      : new Error("Unknown error", { cause: error })

  Bugsnag.notify(typedError)

  clog("Bugsnag notified: %o", typedError)
}
